import React from "react";
import { Answer, DateChoiceQuestion } from "../../../apis";
import { AnswerPartContainer } from "../../layout/AnswerPartContainer";
import { QuestionCardContainer } from "../../layout/QuestionCardContainer";
import { DateChoieRadio } from "../../molecules/DateChoiceRadio";
import { DateChoiceSelect } from "../../molecules/DateChoiceSelect";

type Props = {
  question: DateChoiceQuestion;
  index: string;
  subIndex?: string;
  answerQuestion: (answer: Answer) => Promise<void>;
  answerable: boolean;
  errorMsg?: string;
};

export const DateChoiceCard: React.FC<Props> = ({
  question,
  index,
  subIndex,
  answerQuestion,
  answerable,
  errorMsg,
}) => {
  const options = question.constraints.choices.map((choice) => ({
    label: choice.text,
    value: choice.value,
  }));

  const initChoice = question.answer && {
    label: question.answer.text,
    value: question.answer.value,
  };

  return (
    <QuestionCardContainer
      richQuestionText={question.richText}
      richHelpText={question.richHelpText}
      answerPart={
        <AnswerPartContainer>
          {question.constraints.componentType === "RadioResp" ? (
            <DateChoieRadio
              options={options}
              answerQuestion={answerQuestion}
              initCheck={initChoice}
              answerable={answerable}
            />
          ) : (
            <DateChoiceSelect
              options={options}
              initSelect={initChoice}
              answerQuestion={answerQuestion}
            />
          )}
        </AnswerPartContainer>
      }
      index={subIndex || index}
      errorMsg={errorMsg}
    />
  );
};
